import {
  DESKTOP_CANVAS_SIZE,
  DESKTOP_MAX_RANGE,
  DESKTOP_MIN_RANGE,
  MOBILE_CANVAS_SIZE,
  MOBILE_MAX_RANGE,
  MOBILE_MIN_RANGE,
} from './consts';

import type { BaseBreakpoint } from '@wix/document-services-types';

export const getDesktopBreakpointDefinition = (): BaseBreakpoint => ({
  type: 'BreakpointRange',
  min: DESKTOP_MIN_RANGE,
  max: DESKTOP_MAX_RANGE,
  canvasSize: DESKTOP_CANVAS_SIZE,
});
export const getMobileBreakpointDefinition = (): BaseBreakpoint => ({
  type: 'BreakpointRange',
  min: MOBILE_MIN_RANGE,
  max: MOBILE_MAX_RANGE,
  canvasSize: MOBILE_CANVAS_SIZE,
});
